<se-fe-card [seFeDataFullHeight]="true">
  <se-fe-card-header seFeDataTitle="Included Products" [seFeDataHeavyBorder]="true">
    <div seFeCardHeaderActions>
      <choose-bundle-products-modal
        [bundle]="bundle()"
        [existingProducts]="products()"
        [mode]="mode()"
        (productsSelected)="handleProductsSelected($event)"></choose-bundle-products-modal>
      @if (mode() === 'create' && !isBundleEmpty()) {
        <se-fe-button
          seFeDataEmphasis="low"
          seFeDataSize="small"
          (click)="openChooseProductsModal($event)"
          [seFeDataButtonAttrs]="{'aria-label': 'Choose products'}">
          Choose products
        </se-fe-button>
      }
    </div>
  </se-fe-card-header>
  <se-fe-card-content id="product-detail__included-products">
    @if (isBundleEmpty()) {
      <se-fe-empty-state seFeDataTitle="No products chosen for this product bundle">
        <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_variants" seFeDataSize="950"></se-fe-icon>
        After you choose which products to include in this bundle, they will display here.
        <se-fe-button
          seFeEmptyStateAction
          seFeDataEmphasis="high"
          (click)="openChooseProductsModal($event)"
          [seFeDataButtonAttrs]="{'aria-label': 'Choose products'}">
          Choose products
        </se-fe-button>
      </se-fe-empty-state>
    } @else {
      @if (hasInactiveProducts() && !ineligibleProducts().length) {
        <se-fe-alert seFeDataType="caution" class="inactive-products-alert">
          Not all products are active
          <se-fe-alert-subheader>
            To make this bundle active, all included products must be active.
          </se-fe-alert-subheader>
          <set-to-active-modal
            seFeAlertAction="true"
            [products]="products()"
            (setAllProductsToActive)="handleSetAllProductsToActive()"></set-to-active-modal>
        </se-fe-alert>
      }
      @if (ineligibleProducts().length) {
        <se-fe-alert seFeDataType="caution" class="ineligible-products-alert">
          Some products are not able to be activated.
          <se-fe-alert-subheader>
            <ul>
              @for (product of ineligibleProducts(); track product.id) {
                <li>{{ product.name }} cannot be set to active because it does not have any active variants.</li>
              }
            </ul>
          </se-fe-alert-subheader>
        </se-fe-alert>
      }
      <bundle-products-table
        [products]="products()"
        [loading]="loading()"
        [showBundledPrice]="mode() === 'edit'"
        (removeFromBundle)="handleRemoveFromBundle($event)"></bundle-products-table>
      @if (mode() === 'create') {
        <div class="product-price-total">
          <span class="product-price-total-label">Total original price:</span>
          <span class="product-price-total-value">{{ productPriceTotal() | currency }}</span>
        </div>
        <div [formGroup]="bundlePriceForm">
          <div class="bundle-price-section">
            <se-fe-form-field [seFeDataConfig]="bundlePriceConfig">
              <se-fe-form-field-text
                formControlName="bundlePrice"
                id="bundle-price-input"
                seFeDataAutoComplete="off"
                seFeDataDataType="number"
                seFeDataInputMode="numeric">
                <span seFeFormFieldTextBefore>$</span>
              </se-fe-form-field-text>
            </se-fe-form-field>
            <!-- <se-fe-form-control-help>
              Bundle savings will be calculated after you choose products for this bundle
            </se-fe-form-control-help> -->
          </div>
        </div>
      }

      @if (mode() === 'edit' && bundle()) {
        <div class="product-price-total">
          <span class="product-price-total-label">Total original price:</span>
          <span class="product-price-total-value">{{ productPriceTotal() | currency }}</span>
        </div>
        <div class="bundle-price">
          <p class="bundle-price__label">BUNDLE PRICE</p>
          <p class="bundle-price__value">{{ bundle()!.price_cents / 100 | currency }}</p>
        </div>
      }
    }
  </se-fe-card-content>
</se-fe-card>
